export const FETCH_REDEEM_ASSET = 'FETCH_REDEEM_ASSET';
